import Image from 'next/image';

/**
 * BranchExtraInfoSection 컴포넌트
 * 작성자: AI Assistant
 * 설명: 부가정보(최대 수용 인원, 설립일, 대표전화)를 렌더링합니다.
 * props:
 *   - capacity: 최대 수용 인원
 *   - established: 설립일
 *   - phone: 대표전화
 */

interface BranchExtraInfoSectionProps {
  capacity: number | undefined;
  established?: string;
  phone?: string;
}

export default function BranchExtraInfoSection({
  capacity,
  established,
  phone,
}: BranchExtraInfoSectionProps) {
  // 모든 값이 없으면 섹션 전체를 숨김
  const hasCapacity = capacity !== undefined;
  const hasEstablished = established && established.trim();
  const hasPhone = phone && phone.trim();

  if (!hasCapacity && !hasEstablished && !hasPhone) {
    return null;
  }

  return (
    <div className="desktop:flex desktop:pb-9 gap-4 pb-7">
      <div className="desktop:w-[100px] desktop:items-start desktop:pb-5 flex pb-4">
        <Image
          src="/images/icons/icon_info.svg"
          alt="부가정보"
          width={20}
          height={20}
        />
        <span className="typo-20 text-level-3 pl-2 font-bold">부가정보</span>
      </div>
      <div className="desktop:pl-6 flex flex-col gap-3">
        <div>
          <span className="desktop:typo-18 typo-16 text-level-4 font-bold">
            최대 수용 가능 인원 :
          </span>
          <span className="typo-16 text-level-4 desktop:typo-18 pl-1 font-medium">
            {hasCapacity ? `${capacity.toLocaleString()}명` : '-'}
          </span>
        </div>
        <div>
          <span className="desktop:typo-18 typo-16 text-level-4 font-bold">
            설립일 :
          </span>
          <span className="typo-16 text-level-4 desktop:typo-18 pl-1 font-medium">
            {hasEstablished ? established : '-'}
          </span>
        </div>
        <div>
          <span className="desktop:typo-18 typo-16 text-level-4 font-bold">
            대표전화 :
          </span>
          <span className="typo-16 text-level-4 desktop:typo-18 pl-1 font-medium">
            {hasPhone ? phone : '-'}
          </span>
        </div>
      </div>
    </div>
  );
}
